module.exports = __webpack_public_path__ + "static/_vsaocLogo-ea88932ab7f26ff0295025ad2cb53af3.png";